export const TRANSACTION_TYPE_DEBIT = 'DEBIT';
export const TRANSACTION_TYPE_PREAUTH = 'PREAUTH';

export const TRANSACTION_TYPES = [
  TRANSACTION_TYPE_DEBIT,
  TRANSACTION_TYPE_PREAUTH
];

export const FORM_ORDER = 'order';
export const FORM_CUSTOMER = 'customer';


// WEBPACK FOOTER //
// ./src/order/OrderConstants.js